import { isEmpty } from 'lodash'

const EMPTY_OBJECT = {}

export function groupArrayOfObjectsByKey(elements, key) {
  if (!elements || !Array.isArray(elements) || isEmpty(elements))
    return EMPTY_OBJECT

  return elements.reduce((sortedElements, element) => {
    const elementKey = (element && element[key]) || null
    const existingElements = sortedElements[elementKey] || null
    const normalizedElements =
      existingElements && Array.isArray(existingElements)
        ? existingElements
        : [existingElements]

    sortedElements[elementKey] = existingElements
      ? [...normalizedElements, element]
      : element

    return sortedElements
  }, {})
}
